import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0C4.029 0 0 4.029 0 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zM6.851 1.508C5.244 3.055 4.166 5.546 4.03 8.4h-2.8a7.807 7.807 0 0 1 5.621-6.892zM1.23 9.6h2.8c.136 2.854 1.214 5.345 2.821 6.892A7.807 7.807 0 0 1 1.23 9.6zm7.17 6.621C6.637 15.044 5.387 12.549 5.234 9.6H8.4v6.621zm0-7.821H5.234C5.387 5.451 6.637 2.956 8.4 1.779V8.4zm8.37 0h-2.8c-.135-2.848-1.208-5.334-2.809-6.882 3.064.886 5.357 3.598 5.609 6.882zM9.6 16.221V9.6h3.166c-.153 2.949-1.403 5.444-3.166 6.621zm0-7.821V1.779c1.763 1.177 3.013 3.672 3.166 6.622H9.6zm1.561 8.082c1.601-1.548 2.674-4.034 2.809-6.882h2.8c-.252 3.284-2.545 5.996-5.609 6.882z" />
  </svg>
);

export default SvgComponent;
